<template>
	<div id="app" :class="darkmode?'darkmode':''">
		<div :class="ismobile?'wapClass':'pcClass'">
			<!-- <img src="./assets/logo.png"> -->
			<router-view v-if="isShow" />
		</div>
	</div>
</template>

<script>
	window.onload = function() {
		document.addEventListener('touchstart', function(e) {
			// console.log("1",e.touches.length)
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		})
		document.addEventListener('gesturestart', function(e) {
			// console.log("2")
			e.preventDefault()
		})
	}
	import {
		Checkonline,
		getLangs,
	} from "@/api/urls";
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isShow: true,
				darkmode: false, //黑夜 白天
				ismobile: false, //不是手机端
				actions: [],
				Curlang: {
					label: '',
					img: "",
					value: '',
				},
			};
		},
		created() {
			var that = this;
			// 更新语言
			that.getLanguages();
			// console.log("66666获取黑白模式")
			// 更新在线时长
			if (that.$store.state.token != '') {
				setInterval(() => {
					setTimeout(() => {
						///调取接口获取数据更新在线时长
						// console.log("调取接口获取数据更新在线时长")
						that.Checkonlinefun()
					}, 0)
				}, 55000) //55s调取一次
			}
			var darkmodeval = that.$store.state.darkmode; //获取黑白模式
			// console.log("darkmodeval", darkmodeval)
			if (darkmodeval != null) {
				that.darkmode = darkmodeval;
				if (darkmodeval) {
					// 挂载后给body添加类名
					document.body.classList.add('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-dark.css`);
				} else {
					// 挂载后给body添加类名
					document.body.classList.remove('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-light.css`);
				}
			}

		},
		watch: {},
		mounted() {
			var that = this;
			window.addEventListener('unload', that.saveState) // 监听页面重载
			// 根据不同路由跳转不同页面
			var hcisMobile = that.$store.state.isMobile; //缓存获取是不是手机端
			if (that._isMobile()) {
				console.log('手机端')
				that.ismobile = true;
				that.$store.commit('setisMobile', true)
				if (!hcisMobile) {
					that.$router.replace('/welcome')
				}
			} else {
				console.log('pc端')
				that.ismobile = false;
				that.$store.commit('setisMobile', false)
				if (hcisMobile) {
					that.$router.replace('/pcindex')
				}
			}

		},
		methods: {
			loadDynamicCss(path) {
				const head = document.head;
				const link = document.createElement('link');
				link.type = 'text/css';
				link.rel = 'stylesheet';
				link.href = path;
				head.appendChild(link);
			},
			// 判断是否是手机端，如果是，返回true
			_isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			},
			// 刷新页面
			reload() {
				var that = this;
				var darkmodeval = that.$store.state.darkmode; //获取黑白模式
				// console.log("darkmodeval", darkmodeval)
				if (darkmodeval != null) {
					that.darkmode = darkmodeval;
					if (darkmodeval) {
						document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-dark.css`);
					} else {
						document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-light.css`);
					}
				}
				// console.log("66666获取黑白模式11")
				that.isShow = false;
				that.$nextTick(() => {
					that.isShow = true
				})
			},
			saveState() {
				var that = this;
				console.log(that.$store.state, "app-saveState")
				localStorage.setItem('state', JSON.stringify(that.$store.state)) //把state放入缓存
			},
			//更新在线时长
			Checkonlinefun() {
				var that = this;
				// console.log(that.$store.state.token, "token")
				if (that.$store.state.token == '') {
					return false;
				}
				var params = {
					'lang': that.$store.state.lang,
				}
				Checkonline(params).then(({
					code,
					data
				}) => {
					if (code == 200) {

					} else if (code == 600) {
						// 登录过期
						that.$store.commit('setLoginOut');
						that.reload() //刷新页面
					}
				})
			},
			//获取语言列表
			getLanguages() {
				var params = {
					'lang': this.$store.state.lang,
				}
				getLangs(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// console.log(data, "data")
						this.actions = data;
						this.Curlang = data[0];
						// 获取语言
						var langval = this.$store.state.lang;
						for (var i in this.actions) {
							if (this.actions[i].value == langval) {
								this.Curlang = this.actions[i];
								// console.log(this.Curlang, "获取语言app_key")
							}
						}
						//默认进入的兼容处理
						if (this.Curlang.value == '') {
							this.Curlang = this.actions[0];
							// console.log(this.Curlang, "获取默认语言app_key")
							this.$i18n.locale = 'zh';
							this.$store.commit('setIlang', 'zh')
							this.$store.commit('setLang', 'CN')
						}
					}
				})
			},

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/App.vue